import { render, staticRenderFns } from "./wrappLeaveComment.vue?vue&type=template&id=670d7838&scoped=true&"
import script from "./wrappLeaveComment.vue?vue&type=script&lang=js&"
export * from "./wrappLeaveComment.vue?vue&type=script&lang=js&"
import style0 from "./wrappLeaveComment.vue?vue&type=style&index=0&id=670d7838&lang=scss&scoped=true&"
import style1 from "./wrappLeaveComment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d7838",
  null
  
)

export default component.exports